module.exports = __webpack_public_path__ + "static/media/abt_icon6.169f3dc4.svg";